import scoringApi from '@/api/scoring.api'
import moment from 'moment'
import { DEFAULT_TIMEZONE } from '@/constants/constants'

/**
 * Servicio para recursos de scoring
 */
export const scoringService = (function () {
    'use strict'

    /**
     * Reporte de infracciones descartadas
     * @param {*} driverCodes
     * @param {*} thingIds
     * @param {*} from
     * @param {*} to
     */
    async function getDiscardedInfractionsReport(driverCodes, thingIds, from, to) {
        try {
            const response = await scoringApi.getDiscardedInfractionsReport(driverCodes, thingIds, from, to)
            return response.data
        } catch (exception) {
            console.log(exception)
            return {
                headers: [],
                data: []
            }
        }
    }

    async function processScoringConfigInit(config, timezone) {
        timezone = timezone || DEFAULT_TIMEZONE;
        if (config) {
            config.thirdLevel.nightSchedule.start = config.thirdLevel.nightSchedule.start && moment(config.thirdLevel.nightSchedule.start, 'HH:mm').add(timezone, "hours").format('HH:mm');
            config.thirdLevel.nightSchedule.end = config.thirdLevel.nightSchedule.end && moment(config.thirdLevel.nightSchedule.end, 'HH:mm').add(timezone, "hours").format('HH:mm');
            config.thirdLevel.timezone = timezone;
        }
    }

    async function processScoringConfigSave(config) {
        const timezone = (config.thirdLevel.timezone || DEFAULT_TIMEZONE) * -1;
        config.thirdLevel.nightSchedule.start = config.thirdLevel.nightSchedule.start && moment(config.thirdLevel.nightSchedule.start, 'HH:mm').add(timezone, "hours").format('HH:mm');
        config.thirdLevel.nightSchedule.end = config.thirdLevel.nightSchedule.end && moment(config.thirdLevel.nightSchedule.end, 'HH:mm').add(timezone, "hours").format('HH:mm');
        delete config.thirdLevel.timezone;
    }

    return {
        getDiscardedInfractionsReport,
        processScoringConfigInit,
        processScoringConfigSave
    }
})()
